export function loadAudioEyeScript() {
    window.__AudioEyeSiteHash = "f733a500a8be35f38b6a3743b667eabb"; 
    var a=document.createElement("script");
    a.src="https://wsmcdn.audioeye.com/aem.js";
    a.type="text/javascript";
    a.setAttribute("async","");
    document.getElementsByTagName("body")[0].appendChild(a)
}